import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import {Route, Switch} from "react-router-dom";
import {ToastContainer, style} from "react-toastify";
import ScrollToTop from "./components/ScrollToTop";
import LoginPage from "./components/pages/auth/AuthPage";
import EntityPage from "./components/pages/entity/EntityPage";
import AuthenticatedRoute from "./components/routes/AuthenticatedRoute";
import EntityListPage from "./components/pages/entitylist/EntityListPage";
import {fetchMeta} from "./actions/meta";
import EntityCreatePage from "./components/pages/entitycreate/EntityCreatePage";

style({
    width: "320px",
    colorDefault: "#fff",
    colorInfo: "#3498db",
    colorSuccess: "#173d42",
    colorWarning: "#f1c40f",
    colorError: "#e74c3c",
    colorProgressDefault: "linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55)",
    mobile: "only screen and (max-width : 480px)",
    fontFamily: "'Source Code Pro', monospace",
    zIndex: 9999,
});
// need to pass in location due to a router issue
class App extends React.Component {
    componentDidMount = () => this.onInit(this.props);

    onInit = props => {
        // load from firebase
        props.fetchMeta("ONfZRb51fVNIL9kHNdaU");
    };

    render() {

        const {location, isReady}=this.props;
        if (isReady) {
            return (
                <div>
                    <ToastContainer/>
                    <ScrollToTop>
                        <Route path="/" exact component={LoginPage} location={location}/>

                        <AuthenticatedRoute path="/entity/:entityType" exact component={EntityListPage}
                                            location={location}/>

                        <Switch>
                        <AuthenticatedRoute path="/entity/:entityType/create" exact component={EntityCreatePage}
                                            location={location}/>

                        <AuthenticatedRoute path="/entity/:entityType/:entityId" exact component={EntityPage}
                                            location={location}/>
                        </Switch>
                    </ScrollToTop>
                </div>
            )
        } else {
            return (<div>Loading...</div>);
        }
    }
}
App.defaultProps = {
    isReady:false
};

App.propTypes = {
    fetchMeta: PropTypes.func.isRequired,
    isReady: PropTypes.bool.isRequired,
    location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired
};

const mapStateToProps = (state) => ({
   isReady: state.meta ? true : false,
   meta: state.meta
});

export default connect(mapStateToProps, {fetchMeta})(App);



// WEBPACK FOOTER //
// ./src/App.js